import React from 'react';
import { Box, Badge, Button } from '@mui/material';
import moment from 'moment';

const CustomDayWrapper = ({ children, value, availableDates,selectedDate,handleNavigate}) => {
  const today = new Date();
  const isToday =
    value.getFullYear() === today.getFullYear() &&
    value.getMonth() === today.getMonth() &&
    value.getDate() === today.getDate();
  //   const isCurrentDateGreaterThanToday=    
  //    value >= today
  const toShow= availableDates.some((date) =>
    moment(date).isSame(value, 'day'))

   const isSelected = selectedDate &&  moment(selectedDate).isSame(value, 'day')

  // const dayContent = isToday ? (
    
  //   <Badge color="primary" variant="dot" sx={{marginTop:'35px'}}  >
  //     {/* {children} */}
  //          {value.getDate()} 
 
  //   </Badge>
  // ) : (
  //   // children
  //   value.getDate()
  // );

  return (
     <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%', // Make the Box round
        overflow: 'hidden', // Clip the button to the rounded shape
       // Hide the box if the date is not today
      
      }}
    >
      <Button
        // variant= {isSelected&&toShow?"contained":"outlined"}
        variant={isSelected&&toShow?'contained':'outlined'}
        color="primary" // Use the primary color for blue (usually)
         // Disable the button if the date is not today
         onClick={()=>handleNavigate(value)}
        sx={{
          width: '45px',
          height: '45px',
          borderRadius: '50%',
          border: toShow?'':'none', // Remove default border
           boxShadow:isSelected&&toShow?'0px 4px 8px rgba(0, 0, 0, 0.2)':'',
          // disabled: !toShow, // Disable the button if the date is not today
          color:isSelected? 'white':'black', // Change text color to white
           // Make the button round
          //  visibility: isCurrentDateGreaterThanToday?'visible': 'hidden',
          minWidth: 0, // Remove default minimum width for buttons
          padding: 0, // Remove default padding
          display: 'flex',
          alignItems: 'center',
          textAlign:'center',
          // justifyContent: 'center',
          transition: '0.3s ease-in-out',  
  
          
          'zIndex':10,
          '&:hover': {
            // For contained variant, default Material UI hover adds a slight shadow/darkening
            // For outlined variant, we explicitly add shadow
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)' , // Add shadow on hover if not disabled
            // You might want to adjust background or border on hover for 'outlined' too
            // If variant is 'outlined' and not selected, darken border/text
            // color: (theme) => (isSelected || !toShow ? 'white !important' : theme.palette.primary.dark),
            // borderColor: (theme) => (isSelected || !toShow ? '' : theme.palette.primary.dark),
          },
        }}
      >
      
        {isToday? <Badge color="primary" variant="dot"
   >
    <>{value.getDate()}</> 
      
     </Badge>:value.getDate()
     
     }
         
        {/* {dayContent} */}
      </Button>
    </Box>

  )
};

export default CustomDayWrapper;